import { create } from "zustand"
import { getCookieConsentValue } from "react-cookie-consent"

export const useProfileStore = create((set, get) => ({
    hasAllowedCookies: getCookieConsentValue("profileData") === "true",
    favorites: JSON.parse(localStorage.getItem("favorites")) || [],
    profileData: JSON.parse(localStorage.getItem("profileData")) || {},
    hasOnboarded: localStorage.getItem("hasOnboarded") === "true",

    setHasAllowedCookies: (value) => {
        set({ hasAllowedCookies: value })
    },

    setFavorites: (item) => {
        set((state) => {
            const exists = state.favorites.some(
                (fav) => fav.monternummer === item.monternummer,
            )
            const updatedFavorites = exists
                ? state.favorites.filter(
                      (fav) => fav.monternummer !== item.monternummer,
                  )
                : [...state.favorites, item]

            if (state.hasAllowedCookies)
                localStorage.setItem(
                    "favorites",
                    JSON.stringify(updatedFavorites),
                )

            return { favorites: updatedFavorites }
        })
    },

    setProfileData: (obj = {}) => {
        set({ profileData: obj, hasOnboarded: true })
        if (get().hasAllowedCookies) {
            localStorage.setItem("profileData", JSON.stringify(obj))
            localStorage.setItem("hasOnboarded", "true")
        }
    },

    clearFavorites: () => {
        set({ favorites: [] })
        if (get().hasAllowedCookies)
            localStorage.setItem("favorites", JSON.stringify([]))
    },

    setHasOnBoarded: (value) => {
        set({ hasOnboarded: value })
        if (get().hasAllowedCookies) localStorage.setItem("hasOnboarded", value)
    },
}))
